export class SearchParameter {
    constructor(
        name,
        value
    ) {
        this.name = name
        this.value = value || []
    }
}